var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"couponList"},[_c('button',{class:{item: true, addItem: true},attrs:{"type":"button","disabled":_vm.couponLimit},on:{"click":_vm.setNewItem}},[_vm._v(" + ")]),_vm._l((_vm.list),function(item){return _c('CouponItem',{key:item.cid,attrs:{"locale":_vm.locale,"item":item},on:{"getItem":_vm.setItem}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }